import * as React from 'react';
import { Svg } from '../svg';

function SvgResendLogo({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path fill="url(#resend-logo_svg__pattern0)" d="M0 0h80v80H0z" />
      <defs>
        <pattern
          id="resend-logo_svg__pattern0"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#resend-logo_svg__image0_1347:70630"
            transform="scale(.0125)"
          />
        </pattern>
        <image
          id="resend-logo_svg__image0_1347:70630"
          width={80}
          height={80}
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAGZUlEQVR4Ae2a7W8URRzHGzXxCX2tMdE36gs1Jv4HGt9ojL7Q3M4ikhhfKE8RiYK+IqcIO9uCRiOlCgQ1MTEVYkTFmqZed/YKfaC0COWoWlpaI20ptErRu5ZmzHd357rde+juHU1v92aTzdzuzczO77O/h5nfbE2NPCQBSUASqGIChDIuz9IZ1Eh4pcMDuyzAL7syXJ7+GQjFkwBLVBwJsERwwkolQAnQv78SWnM9S6mBUgOlBoZ62iRNWJqwNGFpwtdzWhC2vsrygYdPZ/ifU3N8do5b58jUHMc9vxDC3h5ylgwQwgOc95i5xn1BDHt7oSQlA4S2FTrwn3hAoTLs7YVcJQPMp30CKLRQPKBQGfb2Qi4JULx1V+lHAcoGWMwEhyfLM+EwtC8bIIIA3pT3CBJEwty+bIDoABChiQCBE5qDe6Lzxcqwt4d8JfvAxeBUy/8SoEwm+HcZS2EVUgOlBkoN9B21l8IEy+1TmrA0YWnC0oTL9SNhbi99oPSBFeYDhUrKMtgHl9nvAyW4YOAEryr+OlyKLgksNQFVM+JL/YzI9g948FORFdAr2Kp4+52K1rqS6GwvoayTUDZOKJshlE0TagyoOjuqaMZHKm17ZnXdydu97d3XAl5VACQ7zAdVau4nlF0Vkc1HeYVQtiv2fss9bnD47YYXaYCxD47eSnRzJ6FsVgDbtK+b72se5L/0XeJdg1f4HxMz1tkzctW6t7f5HN98oCe7oUMoSxPauvXxeOImNzxVN7N1vIAjcf1CrfEA0c1TAty2xj5+fOgKH56a83UeG/ibb//mDCd6du7WBo1Ef4D33fHR6AJUNeMxx7/xNbs7uNk/5QtaPrjQ1Fc/ac/CEvBQV7ycSGicEMLSPDs48Lc/7+VnR9MlwxNA+8fTfOtXp7haa2ueuB85gI7Ps8wW8AYvzebAw73D3aN8x8EUX9/QxV/ameSr6pKWpmoHU/z7E2N88HJuu6HJazmaHDmATsCwYOTTvB96xvja+o6s6QkA3hJ1mk5ezIEvNE+Uop3Q/lCXmKqIaOv1eecn5/junway4BTKfiXU3LiSJh/GfO/Z+PHbYjvYQ7hHKDsjwNR9289/v5gpCFLUCzU4MXhnnscRbYWGiNIFLx2jbG08zm8Q7bxlrLHxRpUyE3Dg85p6x3P6E/1GBiBWGGKS7J2qwGwdQdOKnnzCC8x7LSbJ7mgrgHnLyAC0lmeUcUyS3UIiYAifp2hsjReW9zoIPDwnMgCdta21wnADRLSFkPB5xcwWIAU8ASVI6X0Robt2EgPWUswNEFMVG4S5sZhQ5cBD/8X6DsV/hLKLEKR7aHqBCa9r6LQAIsKGQpDlGiShLAOA3inH6l1tNsB4YsVyjS0Uz10M4Ct68o5QCLJcg5QmXCZ5lbIOmDAyJ+4ggrUt7mOFUeojiMY2231k01pOn/a1orHWUvuumHYqZZ9BSCRK3QDFNAZ5Qawwgg4YSVRCWX8xgIQaWtB+K64+oUyFkPkn0nYkVqmxPujAFZp8C/0imnszNG/uP2FpoqobzwXtt+LqI0gUWsr9OL+Uy6g6e9Lv4GNa4ilnw4n/7MnMdJz7x4ZH2QRSaH77rOh6hJr7oC35kgn185mYDNHZhmLmjBWLk5WxpkZ7mgYWuAW4iPkJOtMrGkqQwTmZaGxRcuPs5AKhkc5yQeSEtp5WNLaJbE88EosnViClhdSWqpuvu9NZaHPes4eCvvEMhbJ/X9zZcl+QMVZ8XaInayHca7s7eOrCfwsgQnNgzmv32D4R9Qqd2Ec50pObxkqNpvmaeru9QtmWigcSdIAvxxO3KNQ4BjAFU/qXZ620PT2U4hs+7eJYrSCtj6wNduGslH6erYCBiRn+zhcnHehGl9jmDDrGiq8fq+28i+hsWEDs+ytXE91THT+/+8fS1guxNFZnw5EzXe9bXVnHHlUoG4HAMEevT/QDTdRJpC7zdfNmfyGmJe73Pi+S19BEYc4A+d7XfdaXCALMYiU21rVDYiXDsMGejNHmeyMJq5BQT3985GZCk+/aHw/ZQeONvd0cn2+0nLY/7UAGB5939I5cte7hvy0HerMBBtFWoea2yPq8QvDc9y2/SFm9G6Tlz4pEYqfuh89vZ3e7+6rq35jzxTSDKNRsIJS1K5SNOamwaULZb9iNw+dtWIVEZoVR1W9cCi8JSAJRIPA/JeiXVFzMjooAAAAASUVORK5CYII="
        />
      </defs>
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgResendLogo);
export default ForwardRef;
